import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Box,
  Typography
} from '@mui/material';
import { User, UserRole, Status } from '../utils/types';

interface Employee extends User {}

interface EmployeesDialogProps {
  open: boolean;
  onClose: () => void;
  employees: Employee[];
  jewelerName: string;
}

export default function EmployeesDialog({ open, onClose, employees, jewelerName }: EmployeesDialogProps) {
  const getStatusChip = (status: Status) => {
    return (
      <Chip
        label={status === Status.ACTIVE ? 'Aktif' : 'Pasif'}
        color={status === Status.ACTIVE ? 'success' : 'error'}
        size="small"
        variant="outlined"
      />
    );
  };

  const getRoleText = (role: UserRole) => {
    switch (role) {
      case UserRole.JEWELER_OWNER:
        return 'Kuyumcu Sahibi';
      case UserRole.JEWELER_EMPLOYEE:
        return 'Kuyumcu Çalışanı';
      default:
        return role;
    }
  };

  const formatDate = (dateString: string | Date) => {
    return new Date(dateString).toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: { minHeight: '500px' }
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">
            {jewelerName} - Çalışan Listesi
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Toplam {employees.length} çalışan
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Ad Soyad</TableCell>
                <TableCell>E-posta</TableCell>
                <TableCell>Telefon</TableCell>
                <TableCell>Kimlik No</TableCell>
                <TableCell>Rol</TableCell>
                <TableCell>Durum</TableCell>
                <TableCell>Kayıt Tarihi</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {employees.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Typography variant="body2" color="text.secondary">
                      Bu kuyumcuda henüz çalışan bulunmuyor
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                employees.map((employee) => (
                  <TableRow key={employee.id} hover>
                    <TableCell>
                      <Typography variant="body2">
                        {employee.firstName || ''} {employee.lastName || ''}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {employee.email}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {employee.phone || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {employee.identity}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {getRoleText(employee.role)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {getStatusChip(employee.status)}
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {formatDate(employee.createdAt)}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
}
